var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTrash1414 = function SvgIconTrash1414(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    fillRule: "evenodd",
    d: "M6.778 2.366a.746.746 0 0 0-.746.745v.746h3.936V3.11a.746.746 0 0 0-.746-.745zm4.143 1.49v-.745a1.7 1.7 0 0 0-1.699-1.699H6.778a1.7 1.7 0 0 0-1.7 1.7v.745H2.5a.477.477 0 1 0 0 .953h.746v8.079a1.7 1.7 0 0 0 1.698 1.699h6.112a1.7 1.7 0 0 0 1.698-1.699V4.81h.746a.477.477 0 1 0 0-.953zM4.2 4.81v8.079a.745.745 0 0 0 .745.746h6.112a.745.745 0 0 0 .745-.746V4.81zm2.579 2.102c.263 0 .476.214.476.477v3.667a.477.477 0 0 1-.953 0V7.389c0-.263.214-.477.477-.477m2.444 0c.263 0 .477.214.477.477v3.667a.477.477 0 0 1-.953 0V7.389c0-.263.213-.477.476-.477",
    clipRule: "evenodd"
  })));
};
export default SvgIconTrash1414;